import React from "react";
import CustomTooltip from "./CustomTooltip";

const SkuToolTip = (props) => {
  const { sku } = props;
  return (
    sku?.length && (
      <>
        <p id="sku-drop" className="w-25 cursor-pointer text-nowrap mb-0">
          {sku[0]}
        </p>
        <CustomTooltip
          anchorSelect={`#${"sku-drop"}`}
          place="bottom-start"
          className={"tooltip-for-text sku-tooltip"}
        >
          {sku.map((sku) => (
            <p className="p-0 m-0">{sku}</p>
          ))}
        </CustomTooltip>
      </>
    )
  );
};

export default SkuToolTip;
